import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CalculatorComponent} from './calculator.component';
import {CalculatorRoutingModule} from './calculator-routing.module';
import {CalculateBoxComponent} from './components/calculate-box/calculate-box.component';
import {ExampleTaxComponent} from './components/example-tax/example-tax.component';
import {InputNumberModule} from './components/input-number/input-number.module';
import {NgbCollapseModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TemplateSlotModule} from '../../../shared/components/template-slot/template-slot.module';
import {DropdownComponent} from './components/dropdown/dropdown.component';
import { NumberOnlyModule } from 'src/app/shared/directives';
import { TaxDetailModule } from './components/tax-detail/tax-detail.module';
import { SelectGroupModule } from 'src/app/shared/components/select-group/select-group.module';
import { LeftCheckboxModule } from 'src/app/shared/components/left-checkbox/left-checkbox.module';


@NgModule({
  declarations: [
    CalculatorComponent,
    CalculateBoxComponent,
    ExampleTaxComponent,
    DropdownComponent,
  ],
  exports: [
  ],
  imports: [
    CommonModule,
    CalculatorRoutingModule,
    InputNumberModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    TemplateSlotModule,
    FormsModule,
    NumberOnlyModule,
    TaxDetailModule,
    SelectGroupModule,
    NgbCollapseModule,
    LeftCheckboxModule,
  ]
})
export class CalculatorModule {
}
